import React from "react";
import { Flex, useMultiStyleConfig, Text } from "@chakra-ui/react";
import NextableChakraImage from "@/components/NextableChakraImage/NextableChakraImage";
import { envVar } from "@/services/env";
import { htmlify } from "@/services/utils";

interface DownloadAllocationModalBodyStageTwoProps {
	shareClassName: string | string[];
	translations?: { [key: string]: string };
}

function DownloadAllocationModalBodyStageTwo({ shareClassName, translations }: DownloadAllocationModalBodyStageTwoProps) {
	const coreStyleParts = useMultiStyleConfig("DownloadAllocationModalBodyCore");
	const styleParts = useMultiStyleConfig("DownloadAllocationModalBodyStageTwo");

	return (
		<Flex sx={coreStyleParts.root}>
			<Flex sx={coreStyleParts.titleContainer}>
				<Text sx={coreStyleParts.titleText}>{htmlify(translations?.fileReadyDownload)}</Text>
			</Flex>
			<Flex sx={styleParts.imageContainer}>
				<NextableChakraImage
					sx={styleParts.image}
					src={`${envVar("PUBLIC_ENV__APP_HOST")}/img/file-success.svg`}
					alt="download image"
					width={300}
					height={300}
				/>
			</Flex>
			<Flex sx={styleParts.documentInfoContainer}>
				{Array.isArray(shareClassName) ? (
					shareClassName.map((name, ind) => {
						return (
							<Text key={ind} sx={styleParts.shareClassText}>
								{htmlify(name)}
							</Text>
						);
					})
				) : (
					<Text sx={styleParts.shareClassText}>{htmlify(shareClassName)}</Text>
				)}
			</Flex>
		</Flex>
	);
}

export default DownloadAllocationModalBodyStageTwo;
